import React, { createContext, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IdleTimerProvider } from "react-idle-timer";
import { useNavigate } from "react-router-dom"; // If you're using React Router for navigation
import CacheUtils from "utils/CacheUtils";
import authApi from "../services/apis/authApi";
import { types } from "store/actions/authActions";
import ROUTES from "routes/constant";

const IdleTimerContext = createContext();

export const useIdleTimerContext = () => useContext(IdleTimerContext);

export const IdleTimerProviderComponent = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // If you're using React Router
  const idleTimerRef = useRef(null);
  const isLoggedIn = useSelector((state) => state.authReducer.isLoggedIn);

  const clearLocalData = () => {
    localStorage.clear();
    sessionStorage.clear();
    CacheUtils.removeAllCache();
    navigate(ROUTES.AUTH.LOGIN);
    dispatch({ type: types.LOGOUT_SUCCESS });
  };
  const onIdle = async () => {
    try {
      await authApi.logout();
      clearLocalData();
    } catch (error) {
      clearLocalData();
    }
  };

  return (
    <IdleTimerProvider
      ref={idleTimerRef}
      timeout={20 * 60 * 1000} // 20 minutes
      onIdle={onIdle}
      disabled={!isLoggedIn}
    >
      <IdleTimerContext.Provider value={idleTimerRef}>
        {children}
      </IdleTimerContext.Provider>
    </IdleTimerProvider>
  );
};
